export default "__VITE_ASSET__D6uXx_TQ__"